// extracted by mini-css-extract-plugin
export default {"title":"uaa-z","warning":"vaa-z","sizeOptionsLegendText":"waa-z"};